import { apiRequest } from "../index";

export const getAllRestaurants = async ({ page = 1, limit = 10 }) => {
  return apiRequest(`/api/admin/restaurant?page=${page}&limit=${limit}`, "GET");
};

export const getRestaurantById = async (restaurantId) => {
  return apiRequest(`/api/admin/restaurant/${restaurantId}`, "GET");
};

export const updateRestaurantStatus = async (restaurantId, data) => {
  return apiRequest(`/api/admin/restaurant/status/${restaurantId}`, "PUT", data);
};

export const updateRestaurantPlatformFee = async (restaurantId, data) => {
  return apiRequest(`/api/admin/restaurant/platform-fee/${restaurantId}`, "PUT", data);
};

export const updateManagerChatAccess = async (data) => {
  return apiRequest(`/api/admin/restaurant/chat-access/${data.restaurantId}`, "PUT", data);
};

